import { render, staticRenderFns } from "./Logi.vue?vue&type=template&id=9f140924&"
import script from "./Logi.vue?vue&type=script&lang=js&"
export * from "./Logi.vue?vue&type=script&lang=js&"
import style0 from "./Logi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports